// const url="https://gis.aacounty.org/app/teamLeader";
const url="http://localhost:3000";

const dev = {
  random: {
    number:"100000000"
  },
  api:{
      covidCases:"https://gis.aacounty.org/arcgis/rest/services/Hosted/Health_Dept_Covid19_Public_View/FeatureServer/2",
      // testingCovid:"https://gis.aacounty.org/arcgis/rest/services/Hosted/Health_Recovery_Data_View/FeatureServer/2",
      testingCovid:"https://gis.aacounty.org/arcgis/rest/services/Hosted/Health_Recovery_Data_3/FeatureServer/2",
      // hospitalCovid:"https://gis.aacounty.org/arcgis/rest/services/Hosted/Health_Recovery_Data_View/FeatureServer/1",
      hospitalCovid:"https://gis.aacounty.org/arcgis/rest/services/Hosted/Health_Recovery_Data_3/FeatureServer/1",
      ethnicityCovid:"https://gis.aacounty.org/arcgis/rest/services/Hosted/Health_Dept_Covid19_Public_View/FeatureServer/3",
      ageCovid:"https://gis.aacounty.org/arcgis/rest/services/Hosted/Health_Dept_Covid19_Public_View/FeatureServer/1"
  },
  apiv2:{
    covidCases:"https://gis.aacounty.org/arcgis/rest/services/COVID-19/Master_COVID_View/FeatureServer/1",
    //covidCases:"https://gis.aacounty.org/arcgis/rest/services/COVID-19/Daily_View/FeatureServer/5",
    covidRecoveryAllTwoWeeks:"https://gis.aacounty.org/arcgis/rest/services/COVID-19/Recovery_View/FeatureServer/3",
    covidRecoveryTwoWeeks:"https://gis.aacounty.org/arcgis/rest/services/COVID-19/Recovery_View/FeatureServer/0",
    vaccine:"https://gis.aacounty.org/arcgis/rest/services/COVID-19/Master_COVID_View/FeatureServer/2",
    //vaccine:"https://gis.aacounty.org/arcgis/rest/services/COVID-19/Vaccine_View/MapServer/1",
    registrationRace:"https://gis.aacounty.org/arcgis/rest/services/COVID-19/Registration_View/MapServer/1",
    registrationStage:"https://gis.aacounty.org/arcgis/rest/services/COVID-19/Registration_View/MapServer/2",
    registrationRaceStage:"https://gis.aacounty.org/arcgis/rest/services/COVID-19/Registration_View/MapServer/3",
    registrationWeekly:"https://gis.aacounty.org/arcgis/rest/services/COVID-19/Registration_View/MapServer/5",
    registrationProvider:"https://gis.aacounty.org/arcgis/rest/services/COVID-19/Registration_View/MapServer/6"
  }
};
  

let config = dev;


export default config